var siteExitModal = new bootstrap.Modal('#site-exit-modal');

$( 'a[href^="//"],a[href^="http"]' ).not( '[href*="' + window.location.hostname + '"]' ).on('click', function(){

	//Hide the exit dialog
	if ($(this).prop('id') === 'site-exit-modal-continue') {
		if($(this).prop('target') === '_blank') $('#site-exit-modal').modal('hide');
		return;
	}
	
	var link = $(this).attr('href');
	var target = $(this).attr('target');
		
	if (link == 'javascript:void(0)' || link.toString().startsWith("#")){
		return false;
	}
	
	$.ajax({
		url: ajaxurl,
		type: 'GET',
		async: true,
		data: {
			'action': 'check_external_link',
			'link': link, 
			'target': target
		}, 
		dataType: "json",
		success: function(response) {
			if (!response.exclude) {
				showExitModal(response);
			}else{
				if(response.target === '_blank'){
					setTimeout(() => {
						window.open(response.url, '_blank');
					});
				}else{
					window.location.href = response.url;
				}
			}
		}
	});
	
	return false;
})

function showExitModal(exclusionCheckResult){
	$('#site-exit-modal-continue').prop('href',exclusionCheckResult.url)
	$('#site-exit-modal-continue').prop('target',exclusionCheckResult.target)
	if(exclusionCheckResult.target === '_blank') $('#site-exit-modal-target-notice').removeClass();
	else $('#site-exit-modal-target-notice').prop('class','d-none');
	siteExitModal.show();
	document.querySelector('#site-exit-modal-continue').addEventListener('click',function () { siteExitModal.hide() });
}
